import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-add-point-side',
  templateUrl: './add-point-side.component.html',
  styleUrls: ['./add-point-side.component.scss'],
  standalone: true,
    imports: [
      IonicModule
    ]
})
export class AddPointSideComponent {
  @Output() addPoint = new EventEmitter<number>();
  @Input({ required: true }) sideNumber: number;
  @Input({ required: true }) rowHeight: number;
  @Input({ required: true }) serverNumber: number;
  @Input({ required: true }) serverSide: number;

  constructor() { }

  addNewPoint(): void {
    this.addPoint.emit(this.sideNumber);
  }
}
